import Axios from "../../../api/axios/Axios";

export const authService = {
  signIn: async (email, password) => {
    const payload = {
      email: email.toLowerCase().trim(),
      password: password.trim(),
    };
    const res = await Axios.post("/api/sign-in", payload);
    return res.data;
  },

  signUp: async (payload) => {
    const res = await Axios.post("/api/sign-up", payload);
    return res.data;
  },

  verifyEmailToken: async (token) => {
    const res = await Axios.post("/api/email-token", { token });
    return res.data;
  },

  resendVerification: async (email) => {
    const res = await Axios.post("/api/resend-email-token", { email });
    return res.data;
  },

  forgotPassword: async (email) => {
    const res = await Axios.post("/api/forgot-password", {
      email: email.toLowerCase().trim(),
    });
    return res.data;
  },

  resetPassword: async (token, password) => {
    const res = await Axios.put("/api/reset-password", {
      token,
      password: password.trim(),
    });
    return res.data;
  },

  verifyResetToken: async (token) => {
    const res = await Axios.post("/api/password-token", {
      token: encodeURIComponent(token),
    });
    return res.data;
  },
};
